module.exports = __webpack_public_path__ + "media/amogus.2d560f43.mp3";